<template>
  <category-form :submit="submit" :formTitle="'Create Category'" role="create"></category-form>
</template>
<script>
import { mapActions } from "vuex";
import { Loading, MessageBox } from "element-ui";
import CategoryForm from "./CategoryForm";
import { userRolesCheck } from "@/util/userRoles";
import Swal from "sweetalert2";

export default {
  components: {
    "category-form": CategoryForm
  },
  methods: {
    ...mapActions("categories", ["createCategory"]),
    submit() {
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      this.createCategory()
        .then((response) => {
          loadingInstance.close();
          Swal.fire({
            icon: "success",
            title: "Create category success",
            text: "Create saved",
            onClose: () => {
              this.$router.push({ name: "Category List" });
            }
          });
        })
        .catch((error) => {
          loadingInstance.close();
          this.$notify({
            message: "Create category failed",
            timeout: 5000,
            icon: "now-ui-icons ui-1_bell-53",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    }
  },
  created() {
    userRolesCheck("create", "category_management");
  }
};
</script>
